"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AND_SYMBOL_REGEX", {
  enumerable: true,
  get: function get() {
    return _regex.AND_SYMBOL_REGEX;
  }
});
Object.defineProperty(exports, "AUTOPLAY_BEHAVIOR", {
  enumerable: true,
  get: function get() {
    return _autoPlayBehavior.AUTOPLAY_BEHAVIOR;
  }
});
Object.defineProperty(exports, "FALSY_VALUES", {
  enumerable: true,
  get: function get() {
    return _falsyValues.FALSY_VALUES;
  }
});
Object.defineProperty(exports, "ORGINAL_SIZE_REGEX", {
  enumerable: true,
  get: function get() {
    return _regex.ORGINAL_SIZE_REGEX;
  }
});
Object.defineProperty(exports, "ORIENTATIONS", {
  enumerable: true,
  get: function get() {
    return _orientations.ORIENTATIONS;
  }
});
var _autoPlayBehavior = require("./auto-play-behavior");
var _falsyValues = require("./falsy-values");
var _orientations = require("./orientations");
var _regex = require("./regex");